import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ContactMe.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import yourPhoto from '../assets/yourPhoto.png';

const ContactMe = () => {
  return (
    <div className="contact-container">
      <img className='contact-image' src={yourPhoto} alt="female voice over artist in india- anushka rath" />
      
      <div>
        <div className="text-container-contact">
          <h1 className="intro-text-contact">
            A fast way to contact me is through  
            <a href="https://www.fiverr.com/s/o8ovoeG" className="fiverr-link"> Fiverr.com</a>. 
            I choose to work on it since it is a great platform for both me and the customers as it provides fraud protection, plenty of features, and a convenient setup for the business. You can find more of my works and many reviews there.
          </h1>
          <br />
          <h2 className="description-text-contact">If you would like to work with me on Fiverr, signup is easy and free!</h2>
          <a href="https://www.fiverr.com/s/o8oBkoA" className="fiverr-button">ORDER ON FIVERR!</a>
        </div>
        
        <div className="info-container-contact">
          <p className="info-text-contact">
            Or you can always feel free to ask your questions on my email address below and I will actively respond!
            <span className="email-text-contact">
              <FontAwesomeIcon icon={faEnvelope} /> anushkarth16@gmail.com
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactMe;
